import classnames from 'classnames'
import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import { Button } from 'semantic-ui-react'

import APP from 'app'
import { Image } from 'images'

import styles from './index.css'

class BackgroundCurve extends PureComponent {
  render() {
    const { className, onRegisterClick, showRegister } = this.props

    return (
      <div className={classnames(styles.wrapper, className)}>
        <div className={styles.title}>
          <h1>
            La plataforma de torneos #1 usada por los aficionados
            {showRegister && (
              <div>
                <Button onClick={onRegisterClick} primary>
                  Registrarse es gratis
                </Button>
              </div>
            )}
          </h1>
        </div>
        <div className={styles.holder}>
          <Image className={styles.image} src={`${APP.url}/img/sweatbits_comunity.png`} />
        </div>
      </div>
    )
  }
}

BackgroundCurve.propTypes = {
  onRegisterClick: PropTypes.func.isRequired,

  className: PropTypes.string,
  showRegister: PropTypes.bool,
}

BackgroundCurve.defaultProps = {
  className: null,
  showRegister: false,
}

export default BackgroundCurve
